import { Form } from 'components/organisms';
import { clientModuleConfigurationInitialValues } from 'components/organisms/forms/settings/ClientModuleConfigurationForm';
import {
  useClientModuleConfiguration,
  useUpdateClientModuleConfiguration,
  useUpdateClientModuleLogo,
} from 'services/settings/client-module';
import { IClientModuleConfigurationForm } from 'services/settings/client-module/types';
import { onErrorShowAllErrorsToast } from 'utils/service/errorHandler';

const ClientModuleConfiguration = () => {
  const clientModuleConfiguration = useClientModuleConfiguration();

  const updateClientModuleConfiguration = useUpdateClientModuleConfiguration();
  const updateClientModuleLogo = useUpdateClientModuleLogo();

  const onSubmit = async (values: IClientModuleConfigurationForm) => {
    await updateClientModuleConfiguration.mutateAsync(values, {
      onSuccess: async data => {
        if (values.file) {
          return await updateClientModuleLogo.mutateAsync(
            {
              file: values.file,
              //! "What doesn't kill you makes you stronger" ~ Nietzsche
              id: (data.id as unknown as { value: string })?.value,
            },
            {
              onSuccess: async () => await clientModuleConfiguration.refetch(),
              onError: async error => {
                await clientModuleConfiguration.refetch();
                onErrorShowAllErrorsToast(error);
              },
            }
          );
        }
        await clientModuleConfiguration.refetch();
      },
      onError: error => onErrorShowAllErrorsToast(error),
    });
  };

  return (
    <Form.ClientModuleConfiguration
      status={{
        isLoading: clientModuleConfiguration.isLoading,
        displayMode: true,
      }}
      initialValues={
        clientModuleConfiguration.data
          ? clientModuleConfiguration.data
          : clientModuleConfigurationInitialValues
      }
      i18nextPrefix='client-module-configuration'
      onSubmit={onSubmit}
    />
  );
};

export default ClientModuleConfiguration;
